// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"554":"c359d5e6","787":"2aacac6f"}[chunkId] + ".chunk.js";
};